import {
  canControlOwnSession,
  canStartWorkOnStatus,
  canViewSuggestedInternalRepairCost,
  formatElapsedSeconds,
  type CommercialViewer,
} from "./roWorkTimer";
import { JOB_STATUS_LABELS } from "./serviceConstants";

export function canShowRoStartWork(input: {
  viewer: CommercialViewer | null | undefined;
  assignedTechnicianId: number | null;
  status: string;
}): boolean {
  if (!input.viewer?.userId) return false;
  if (!canControlOwnSession(input.viewer, { assignedTechnicianId: input.assignedTechnicianId })) return false;
  return canStartWorkOnStatus(input.status) == null;
}

export function roHeaderStatusLabel(status: string, ownTimerRunning: boolean): string {
  if (ownTimerRunning) return "Repair in progress";
  return JOB_STATUS_LABELS[status] ?? status;
}

type TimerAuditValue = {
  durationSeconds?: number | null;
};

function parseTimerValue(value: unknown): TimerAuditValue | null {
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    const parsed = JSON.parse(value) as unknown;
    return parsed && typeof parsed === "object" ? (parsed as TimerAuditValue) : null;
  } catch {
    return null;
  }
}

const STOP_ACTIONS = new Set([
  "work_session_stopped",
  "work_session_admin_recovery_stop",
  "work_session_automatic_eod_stop",
  "work_session_automatic_final_cutoff",
]);

/** Sum of server-recorded stopped sessions already present on the audit log. */
export function recordedWorkLabel(
  entries: Array<{ action: string; newValue?: unknown }>,
  ownTimerRunning: boolean,
): string {
  let seconds = 0;
  for (const entry of entries) {
    if (!STOP_ACTIONS.has(entry.action)) continue;
    const value = parseTimerValue(entry.newValue);
    if (typeof value?.durationSeconds === "number" && value.durationSeconds > 0) {
      seconds += value.durationSeconds;
    }
  }
  if (seconds <= 0) return ownTimerRunning ? "In progress" : "Not started";
  return ownTimerRunning ? `${formatElapsedSeconds(seconds)} recorded · in progress` : formatElapsedSeconds(seconds);
}

export function canShowSuggestedRepairCost(
  viewer: CommercialViewer | null | undefined,
  job: { assignedTechnicianId?: number | null },
): boolean {
  return canViewSuggestedInternalRepairCost(viewer, job);
}
